<template>
  <div v-if="item.title">
    <WaveWidget />

    <v-sheet color="primary">
      <v-container class="py-10 py-md-13 py-lg-16 item">
        <v-row align="center" justify="center">
          <template v-if="!smAndDown && item.img">
            <v-col md="6">
              <img
                class="d-block item-img"
                :src="files + item.img + '?resize=1&w=600'"
                :alt="item.title"
                width="100%"
              />
            </v-col>
          </template>

          <v-col
            :class="{ 'pl-md-10': !smAndDown && item.img }"
            cols="12"
            sm="10"
            md="6"
          >
            <div
              class="
                white--text
                text-h5 text-md-h4
                font-weight-bold
                text-center text-md-left
                item-title
              "
            >
              {{ item.title }}
            </div>

            <template v-if="smAndDown && item.img">
              <img
                class="d-block mx-auto mt-6 item-img"
                :src="files + item.img + '?resize=1&w=600'"
                :alt="item.title"
                width="100%"
              />
            </template>

            <div
              v-if="item.introduction || item.text"
              class="
                white--text
                text-body-1 text-justify
                font-weight-regular
                mt-4
                ck-content
                item-text
              "
              v-html="item.introduction || item.text"
            ></div>

            <ButtonWidget
              class="mt-6"
              :to="path"
              text-color="white"
              :align="smAndDown ? 'center' : 'left'"
            >
              Saiba Mais
            </ButtonWidget>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import WaveWidget from "../widgets/WaveWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
};

const _data = {
  path: "/quem-somos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    WaveWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 585 / 420;
    border-radius: 20px;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }

  &-text {
    line-height: 1.8;
  }
}
</style>
